import React,{createContext, useRef,useState} from 'react'
import {Outlet} from 'react-router-dom'
import '../../styles/devotional.css'
import '../../styles/common.css'


import DevotionalHeader from './devotionalHeader'
import ScrollUp from '../common/scrollUp'
import ScrollRestoration from '../common/onWindowLoadUp'
import RouteTracker from '../common/routeTracker'
import DevotionalFooter from './devotionalFooter'
import ShareSidebar from './socialShare'

 export  const DeviceContext = createContext(); 

 

const Devotional = ({isMobile}) => {

             const devotionalMainContainerRef = useRef(null);
             const [mobile,setMobile] = useState(isMobile)





  return (
       <div className='devotional-container' ref={devotionalMainContainerRef}>
        
         <DevotionalHeader />
       
         <div className='devotional-main-container container-fluid g-0'>
          <div className='row g-0'>
         <div className='col-none col-lg-1'></div>
          <DeviceContext.Provider value={{mobile,setMobile,containerRef:devotionalMainContainerRef}}>
         <div className='col-12 col-lg-10'>
            <div className='devotional-content shadow-lg'>
              <Outlet />
            </div>
          </div>
          </DeviceContext.Provider>
         <div className='col-none col-lg-1'></div>  
          </div>
          <div className='row g-0'>
           <div className='col-none col-lg-1'></div>
            <div className='col-12 col-lg-10'>
                <DevotionalFooter  />
          </div> 
           <div className='col-none col-lg-1'></div>
          </div>
          </div>

           <ScrollUp containerSelector={'.devotional-container'} />
                       <ScrollRestoration containerRef={devotionalMainContainerRef} />
                      <RouteTracker />
         
          {!mobile && <ShareSidebar />} 
        
       </div>
  )
}

export default Devotional;


